import React from 'react'
import { Box, SearchInput, Text } from '@workwhile/ui'
import { useCompaniesContextValue } from '../context/CompaniesProvider'

export const Search = () => {
  const {
    state: { searchInput, foundClosestAutocompleteMatch },
    actions: { setSearchInput },
  } = useCompaniesContextValue()
  return (
    <Box mb={3} maxWidth={['100%', '100%', '100%', '50%']}>
      <SearchInput
        keyword={searchInput}
        setKeyword={setSearchInput}
        placeholder="Search by name or ID"
        block
        clearable={false}
      />

      <Text
        color="lightText"
        mt={2}
        style={{
          // We use visibility to avoid layout shift when the text is hidden
          visibility: foundClosestAutocompleteMatch ? 'visible' : 'hidden',
        }}
      >
        Did you mean "{foundClosestAutocompleteMatch}"?
      </Text>
    </Box>
  )
}
